import "@/lib/fonts";
import "@/styles/globals.css";
import { SITE } from "@/data/site";
import Noise from "@/components/shared/Noise";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import TransitionProvider from "@/components/layout/TransitionProvider";
import HelpIcon from "@/components/shared/HelpIcon";

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  return (
    <div data-app="oddstack">
      <Noise />
      <Nav />
      <TransitionProvider>{children}</TransitionProvider>
      <Footer />
      <HelpIcon />
    </div>
  );
}
